import React from 'react'
import ScheduleFetcher from './ScheduleFetcher'; 

 const Checkin = () => {
   return (
     <div className='font-poppins'>
         <ScheduleFetcher />
     </div>
   )
 }

 export default Checkin